<template>
  <fieldset>
    <div class="form-group">
      <label :for="yearInputId">{{ trans("forms.yearLabel") }}</label>
      <select2 :id="yearInputId" name="year" :options="years" />
    </div>
    <ProductFormGroup :data-available-products="dataAvailableProducts" />
    <RegionFormGroup :data-available-regions="dataAvailableRegions" />
    <CenterFormGroup :data-available-centers="dataAvailableCenters" />
    <ExcludeTogglesFieldset />
  </fieldset>
</template>
<script setup>
import { v4 as uuidV4 } from "uuid";
import RegionFormGroup from "./comp/RegionFormGroup.vue";
import CenterFormGroup from "./comp/CenterFormGroup.vue";
import ProductFormGroup from "./comp/ProductFormGroup.vue";
import ExcludeTogglesFieldset from "./comp/ExcludeTogglesFieldset.vue";
import Select2 from "../../../../../components/Utils/select2.vue";

const yearInputId = uuidV4();

const currentYear = new Date().getFullYear();
const length = currentYear - 2011;
const years = Array.from({ length }, (_, i) => {
  return currentYear - i;
});

defineProps({
  dataAvailableRegions: {
    type: /** @type {Array<{ id: number, text: string }>} */ Array,
    required: true,
  },
  dataAvailableCenters: {
    type: /** @type {Array<{ id: number, text: string }>} */ Array,
    required: true,
  },
  dataAvailableProducts: {
    type: /** @type {Array<{ id: number, text: string }>} */ Array,
    required: false,
  },
  dataFormErrors: {
    type: /** @type {Record<'ssn'|'fromDate'|'untilDate', string|string[]>} */ Object,
  },
});
</script>
